module.exports = "/_next/static/resources/box-1c80eee5ab773d52cc8d4708a8f44764.webp";